import React, {
  useContext,
  useMemo,
  useState,
} from 'react'
import {
  shallowEqual,
  useSelector,
} from 'react-redux'

import { ForgetMeContext } from 'components/blocks/Modal/ForgetMe/context'

import {
  getQuoteRequestValue,
  isQuoteRequestPristine,
} from 'state/quotes/selectors'

import { RootState } from 'state/types'

import QuotingStart from './index.presentational'

const QuotingStartContainer: React.FC = (): React.ReactElement => {
  const [
    isAccepted,
    setIsAccepted,
  ] = useState(false)

  const isPristine = useSelector(isQuoteRequestPristine)

  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  const showInputs = useMemo(() => isPristine || isAccepted, [ isAccepted ])

  const { setIsOpen: setIsForgetMeOpen } = useContext(ForgetMeContext)

  const [
    applicantFirstName,
    applicantLastName,
  ] = useSelector((state: RootState) => [
    getQuoteRequestValue(state, 'applicant.personalInfo.name.firstName'),
    getQuoteRequestValue(state, 'applicant.personalInfo.name.lastName'),
  ], shallowEqual)

  return React.createElement(QuotingStart, {
    applicantFirstName,
    applicantLastName,
    showInputs,
    onClickContinue: () => {
      setIsAccepted(true)
    },
    onClickReset: () => {
      setIsForgetMeOpen(true)
    },
    onForgetMeConfirm: () => {
      setIsAccepted(true)
    },
  })
}

export default QuotingStartContainer
